module.exports = __webpack_public_path__ + "fonts/inter.d65c366e.woff2";